<template>
	<div>
		<div class='text-h3 font-weight-bold text-end'>
			{{ currentTimeDateFormat }}
		</div>
		<div v-if="showCurrentDay" class='text-h5 font-weight-bold text-end'>
			{{ currentDay }}
		</div>
		<div class='text-h5 font-weight-bold text-end'>
			{{ currentTimeHourMinutesFormat }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'CurrentDateAndTimeDisplay',
	props: {
		generalInformation: {
			type: Object,
			required: true
		},
		showCurrentDay: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	computed: {
		currentDay() {
			return this.generalInformation?.currentTime?.format('dddd');
		},
		currentTimeHourMinutesFormat() {
			return this.generalInformation?.currentTime?.format('LTS');
		},
		currentTimeDateFormat() {
			return this.generalInformation?.currentTime?.format('L');
		}
	}
};
</script>

<style scoped>

</style>
